import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import SelectList from 'components/common/SelectList'
import messages from 'routes/App/Dashboard/translate'
import { fetchSiteList } from 'reducers/dashboard/growth/reducer'
import { setActiveDate } from 'reducers/slaMonitor/reducer'
import { setSiteContext } from 'reducers/profile/reducer'
import ArrayHelper from 'helpers/array'
import ProfileHelper from 'helpers/profile'

class FilterBar extends Component {
  componentDidMount() {
    this.props.fetchSiteList()
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.siteList !== nextProps.siteList &&
      nextProps.siteList.size > 0
    ) {
      if (
        nextProps.activeSite === 0 ||
        (nextProps.activeSite !== 0 &&
          !ArrayHelper.hasInArray(
            nextProps.siteList.toArray(),
            nextProps.activeSite,
            'id',
          ))
      ) {
        const activeSite = nextProps.siteList.get(0)
        this.props.setSiteContext({ site: activeSite.id })

        return false
      }
    }

    return true
  }

  onSiteChange = value => {
    if (value) {
      const { siteList, activeSite } = this.props

      if (activeSite !== value.index) {
        this.props.setSiteContext({ site: siteList.get(value.mapKey).id })
      }
    }
  }

  dateRangeChange = false

  onDateChange = value => {
    if (!this.dateRangeChange) {
      this.props.setActiveDate(moment(value))
      this.dateRangeChange = true
    } else {
      this.dateRangeChange = false
    }
  }

  render() {
    const {
      siteList,
      activeSite,
      activeDate,
      intl: { formatMessage },
    } = this.props
    const locale = ProfileHelper.getCurrentLocale()

    return (
      <Grid container spacing={1}>
        <Grid item lg={3} md={4} sm={6} xs={12} className="avatar-block">
          <SelectList
            variant="outlined"
            name="site"
            label={formatMessage(messages.site_list)}
            onChange={this.onSiteChange}
            list={siteList}
            value={activeSite}
            map={{
              index: 'id',
              text: 'name',
            }}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={3} xs={12} className="avatar-block">
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DatePicker
              fullWidth
              autoOk
              disableToolbar
              disableFuture
              variant="inline"
              format="dd/MM/yyyy"
              id="date-picker-inline"
              label="DD-MM-YYYY"
              value={activeDate}
              onChange={this.onDateChange}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    )
  }
}

export default connect(
  state => ({
    siteList: state.getIn(['dashboardGrowth', 'siteList']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    activeSite: state.getIn(['profile', 'siteId']),
  }),
  {
    fetchSiteList,
    setSiteContext,
    setActiveDate,
  },
)(injectIntl(FilterBar))
